import { z } from "zod";
import { IsoDateTimeSchema } from "../common/primitives.js";
const ClientErrorReportSchema = z.strictObject({
  kind: z.enum(["error", "unhandledrejection", "boundary"]),
  name: z.string().max(100),
  message: z.string().max(500),
  stack: z.string().max(4e3).optional(),
  componentStack: z.string().max(4e3).optional(),
  /** Path only, e.g. "/o/0190…/activity" (no query string, no fragment). */
  route: z.string().max(300).regex(/^\/[^?#]*$/, "route must be a path without query string or fragment"),
  /** Build identifier of the web app. */
  release: z.string().max(50),
  occurredAt: IsoDateTimeSchema,
  /** traceId of the API error that caused it, if any. */
  traceId: z.string().max(64).optional()
});
export {
  ClientErrorReportSchema
};
//# sourceMappingURL=index.js.map